<template>
  <component
    :is="tag"
    @click.capture.native="handleNavClick"
    class="nav-item"
    :class="{ 'sidebar-nav-item--sub': variant === 'sub' }"
    v-bind="$attrs"
    tag="li"
  >
    <a class="nav-link sidebar-nav-link" :class="{ 'sidebar-nav-link--sub': variant === 'sub' }">
      <slot>
        <i v-if="icon" :class="icon" class="sidebar-nav-link__icon" aria-hidden="true"></i>
        <span class="sidebar-nav-link__label">{{ name }}</span>
      </slot>
    </a>
  </component>
</template>
<script>
export default {
  name: "sidebar-link",
  inheritAttrs: false,
  inject: {
    autoClose: {
      default: true,
    },
    addLink: {
      default: () => {},
    },
    removeLink: {
      default: () => {},
    },
  },
  props: {
    name: String,
    icon: String,
    variant: {
      type: String,
      default: "main",
    },
    sameRouteResetEvent: {
      type: String,
      default: null,
    },
    tag: {
      type: String,
      default: "router-link",
    },
  },
  methods: {
    hideSidebar() {
      if (this.autoClose) {
        this.$sidebar.displaySidebar(false);
      }
    },
    handleNavClick() {
      this.hideSidebar();
      if (!this.sameRouteResetEvent) return;
      if (typeof window === "undefined") return;
      window.dispatchEvent(new CustomEvent(this.sameRouteResetEvent));
    },
    isActive() {
      return this.$el.classList.contains("active");
    },
  },
  mounted() {
    if (this.addLink) {
      this.addLink(this);
    }
  },
  beforeDestroy() {
    if (this.removeLink) {
      this.removeLink(this);
    }
  },
};
</script>
<style scoped>
.sidebar-nav-link {
  text-align: center;
}

.sidebar-nav-link__label {
  letter-spacing: 0.01em;
}

.sidebar-nav-link--sub {
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  min-height: 0;
  padding: 8px 10px 8px 14px;
  text-align: left;
}

.sidebar-nav-link--sub .sidebar-nav-link__icon {
  font-size: 0.8rem;
  flex-shrink: 0;
}

.sidebar-nav-link--sub .sidebar-nav-link__label {
  font-size: 0.68rem;
  -webkit-line-clamp: 2;
  text-align: left;
}
</style>
